
class ItemModifier extends React.Component {
  render () {
    const {modifiers} = this.props
    return (<div className={`checkbox checkbox-primary checkbox-item checkbox-circle ng-scope checkbox-circle no-padding`}>
      {modifiers.map((modifier, index) =>
        <div className='top-8 checkbox-input'>
          <input
            type='checkbox'
            checked={this._checked(modifier.id)}
            onChange={(e) => this._onChangeCheckbox(e, modifier.id)}
            id={`modifier-${modifier.id}`}
            className='item-form-checkbox'
          />
          <label for={`modifier-${modifier.id}`}>{modifier.name}</label>
        </div>
      )}
    </div>)
  }

  _onChangeCheckbox = (e, id) => {
    const {fields, modifiers} = this.props
    const values = fields.getAll() // Take Note

    let indexPosition = -1
    values.forEach((value, index) => {
      if (value.id === id) {
        indexPosition = index
      }
    })
    if (indexPosition === -1) {
      // the value doesn't exist, insert data
      modifiers.forEach((modifier) => {
        if (modifier.id === id) {
          fields.push(modifier)
        }
      })
    } else {
      // remove the value
      fields.remove(indexPosition)
    }
  }

  _checked = (id) => {
    const {fields} = this.props
    const values = fields.getAll()
    let checked = false
    if (values) {
      values.forEach((val) => {
        checked = checked || (val.id === id)
      })
    }
    return checked
  }
}

export default ItemModifier



// WEBPACK FOOTER //
// ./app/pages/Library/Item/ItemDetail/ItemForm/ItemModifier/ItemModifier.js